import React, { useEffect, useMemo } from 'react';
import { PlpTile } from 'src/scripts/templates/product-listing-page/components/PlpTiles';
import ErrorBoundary from 'src/scripts/utils/react/ErrorBoundary';
import { ProductNode } from 'src/scripts/templates/product-listing-page/types';
import { checkIfCustomer } from '../../../utils/helpers';
import {
  getAloSuggestedProducts,
  getPlpTileCompliantProductNodes,
  trackRecentSearch,
} from 'src/scripts/sections/header/Search/utils';

const NoResultsPage = ({ query }: { query: string }) => {
  const { searchDeadEndSuggestedTerms = {} } = window.AloSearchSettings;
  const [suggestedProducts, setSuggestedProducts] = React.useState<ProductNode[]>([]);

  useEffect(() => {
    if (window.AloSearchSettings && window.AloSearchSettings.suggestedProducts) {
      const aloSuggestedProducts = getAloSuggestedProducts(window.AloSearchSettings.suggestedProducts);
      (async () => {
        const plpTileCompliantSuggestedProductNodes = await getPlpTileCompliantProductNodes(aloSuggestedProducts);
        setSuggestedProducts(plpTileCompliantSuggestedProductNodes);
      })();
    }
  }, []);

  const isCustomer = useMemo(() => {
    return checkIfCustomer();
  }, []);

  const isWishlist = window.location.href.includes('view=wishlist');

  const suggestionList = Object.keys(searchDeadEndSuggestedTerms);
  return (
    <>
      <div className="no-results-header d-flex fw-grid__wrapper">
        <h4 className="h4">
          Sorry, we couldn't find <q>{query}</q>
        </h4>
        {suggestionList.length > 0 ? (
          <>
            <p className="body">Try adjusting your search or try one of these suggested search terms:</p>
            <ul className="trending-searches d-flex">
              {suggestionList.map((key: string) => (
                <li>
                  <a href={searchDeadEndSuggestedTerms[key]} onClick={() => trackRecentSearch(key)}>
                    {key}
                  </a>
                </li>
              ))}
            </ul>
          </>
        ) : null}
        <p className="no-results-contact-link">
          Need help? <a href="/pages/contact-us">Contact Us</a>
        </p>
      </div>
      <div className="popular-products-container">
        <div className="popular-products-heading">
          {suggestedProducts.length > 0 ? <h4 className="h4 semibold black uppercase">You may also like</h4> : null}
        </div>
        <div className="popular-products search-page-plp">
          {suggestedProducts.map((product: ProductNode, index: number) => (
            <div className="search-page-product-tile popular-product" key={`suggestedProducts-${index}`}>
              <ErrorBoundary key={product.id}>
                <PlpTile
                  productData={product}
                  key={product.id}
                  index={index}
                  isCustomer={isCustomer}
                  isWishlist={isWishlist}
                  collectionHandle={'search-page-drawer'}
                  collectionShopifyId={''}
                  hasAFilterSelected={false}
                  source="Search Dead End"
                />
              </ErrorBoundary>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default NoResultsPage;
